import {MutableMessageTemplate, template as tpl} from "./mutable";
import {global} from "../../appContext";
import PromiseRequest from "../../req/PromiseRequest";
import {IRouteDefinitionParams} from "../../index";
import {trackSurvicateEvent} from "../../util/survicate";

export let template: string = tpl;

export class viewModel extends MutableMessageTemplate {

    private defaultsmtpsender!: string;
    protected readonly req_submit: PromiseRequest = global.getPromiseRequest("createmessage");
    protected readonly submitSuccessMessage: string = `subject is created|s:((messageflow))`

    constructor(params: IRouteDefinitionParams) {
        super(params);

        this.kosub.subscribeChanged(this.data.messagetype, (newValue, oldValue) => {
            // RECIPIENTFIELD
            if (this.isType('email') && this.isType('custom')) {
                this.data.recipientfield('')
            } else if (this.isType('email', 'task', 'message')) {
                this.data.recipientfield('Email');
            }

            // SENDER
            switch (this.typeChecker.getType()?.[0]) {
                case 'sms':
                    this.data.sender(this.availableSmsSenders[0] ?? '');
                    break;
                case 'email':
                    if (oldValue?.id == null || ![3, 4, 5].includes(oldValue.id)) {
                        this.data.sender(this.defaultsmtpsender);
                    }
                    break;
                default:
                    this.data.sender('');
                    break;
            }
        });
        this.init();
    }

    protected override init(): Promise<void> {
        return super.init()
            .then(() => this.defaultsmtpsender = this.company.defaultsmtpsender)
            .then(() => this.initMessageType())
            .then(() => this.initSyncStep())
            .then(this.initAfter.bind(this))
            .catch(this.initError.bind(this));
    }

    override onSubmit() {
        trackSurvicateEvent('ces.messageflow.create');
        super.onSubmit();
    }

}
